import * as React from 'react'
import * as ReactDom from 'react-dom'
import { EvwContainer } from './components/containers/EvwContainer'
import { TranslatorProvider } from 'react-translate'
import { FeesContainer } from './components/containers/FeesContainer'
import AccountStatementContainer from './components/containers/AccountStatementContainer'
import VersionManagerContainer from './components/containers/VersionManagerContainer'
import SettingsFeesApp from './components/containers/SettingsFeeApp'
import getTranslations from './translations'

const win = window as any
// This solves a local grunt / webpack combo issue where react is instantiated twice.
// It does not impact the prod build
if (!win.reactLoaded) {
  win.renderSettingsFee = function (accountId: string, marketplaceId: number, showEdit: boolean, language: string) {
    let translations = getTranslations(language)

    ReactDom.unmountComponentAtNode(document.getElementById('md3-fees'))
    ReactDom.render(
      <TranslatorProvider translations={translations}>
        <SettingsFeesApp accountId={accountId} marketplaceId={marketplaceId} showEdit={showEdit} />
      </TranslatorProvider>,
      document.getElementById('md3-fees')
    )
  }

  win.renderEvwScreen = function (language: string) {
    let translations = getTranslations(language)
    ReactDom.unmountComponentAtNode(document.getElementById('md3-evw'))
    ReactDom.render(<TranslatorProvider translations={translations}><EvwContainer /></TranslatorProvider>, document.getElementById('md3-evw'))
  }

  const AccountsFeeDisplayApp = (props: any) => {
    return (
      <div style={{
        marginBottom: '15px',
        marginTop: '-50px',
        width: '485px'
      }} >
        <FeesContainer
          accountId={props.accountId}
          accountCategoryId={props.accountCategoryId}
          marketplaceId={props.marketplaceId}
          readOnly={true}
          feeView='account'
          key='myAccountFeesView'
          header=''
          containerStyle={{ marginTop: '60px' }}
        />
      </div>
    )
  }

  win.renderAccountFeeDisplay = function (accountId: string, accountCategoryId: number, marketplaceId: number, language: string) {
    let translations = getTranslations(language)

    ReactDom.unmountComponentAtNode(document.getElementById('md3-view-fees'))
    ReactDom.render(
      <TranslatorProvider translations={translations}>
        <AccountsFeeDisplayApp accountId={accountId} accountCategoryId={accountCategoryId} marketplaceId={marketplaceId} />
      </TranslatorProvider>,
      document.getElementById('md3-view-fees')
    )
  }

  const AccountsEditFeesApp = (props: any) => {
    return (
      <div style={{
        marginBottom: '15px',
        marginTop: '-30px',
        width: '485px'
      }} >
        <FeesContainer
          accountId={props.accountId}
          accountCategoryId={props.accountCategoryId}
          marketplaceId={props.marketplaceId}
          feeView='account'
          key='accountFeesView'
          header=''
          cancelActionFn={props.cancelActionFn}
          feeUpdateFn={props.feeUpdateFn}
        />
      </div>
    )
  }

  win.renderAccountEditFee = function (
    accountId: string, accountCategoryId: number, marketplaceId: number, cancelActionFn: any, feeUpdateFn: any, language: string) {
    let translations = getTranslations(language)

    ReactDom.unmountComponentAtNode(document.getElementById('md3-edit-fees'))
    ReactDom.render(
      <TranslatorProvider translations={translations}>
        <AccountsEditFeesApp accountId={accountId} accountCategoryId={accountCategoryId} marketplaceId={marketplaceId} cancelActionFn={cancelActionFn} feeUpdateFn={feeUpdateFn} />
      </TranslatorProvider>,
      document.getElementById('md3-edit-fees')
    )
  }

  win.renderAccountStatement = function(language: string) {
    let translations = getTranslations(language)
    ReactDom.unmountComponentAtNode(document.getElementById('md3-account-statement'))
    ReactDom.render(
      <TranslatorProvider translations={translations}>
        <AccountStatementContainer language={language} />
      </TranslatorProvider>,
      document.getElementById('md3-account-statement')
    )
  }

  // Instantiated from load.ts
  win.renderVersionManager = function () {
    ReactDom.render(
      <VersionManagerContainer />,
      document.getElementById('md3-version-manager')
    )
  }

  win.renderVersionManager()
  win.reactLoaded = true
}



// WEBPACK FOOTER //
// ./react/index.tsx